import { Card, FlexGrid, stl } from '@algolia/satellite'
import type { FunctionComponent } from 'react'

import algolia from '../../assets/images/algolia-logo-blue.svg'
import algoliaLogo from '../../assets/images/algolia-small.svg'

const ErrorBoundaryHtml: FunctionComponent = () => {
    return (
        <>
            <div className="header-bar stl-w-full stl-p-5 stl-text-left stl-bg-white stl-flex stl-items-center">
                <FlexGrid spacing="sm" alignment="center">
                    <a href="/">
                        <img
                            src={algoliaLogo}
                            className={stl`display-heading mr-4 w-6`}
                        />
                    </a>
                </FlexGrid>
            </div>
            <FlexGrid
                className={stl`w-full h-full min-h-screen p-10 bg-grey-50 App-bg`}
                direction="column"
                alignment="center"
                spacing="md"
                wrap={true}
            >
                <Card
                    fullBleed
                    className={stl`max-w-96`}
                    style={{
                        background: 'linear-gradient(#fff,#f5f5fa)',
                        boxShadow:
                            '0 5px 15px 0 rgb(37 44 97 / 15%), 0 2px 4px 0 rgb(93 100 148 / 20%)',
                    }}
                >
                    <FlexGrid
                        className={stl`w-full h-full min-h-screen p-6 bg-grey-50`}
                        direction="column"
                        alignment="center"
                        spacing="sm"
                        wrap={true}
                    >
                        <div
                            style={{ fontSize: '36px' }}
                            className={stl`p-6 pb-2`}
                        >
                            There’s a problem loading this page
                        </div>
                        <div className={stl`typo-display-body p-6`}>
                            There is a technical problem that has prevented this
                            page from loading. Please try reloading this page.
                        </div>

                        <div className={stl`p-6`}>
                            <div
                                className={stl`typo-display-heading stl-items-center`}
                                style={{ textAlign: 'center' }}
                            >
                                Need Help?
                            </div>
                            <a href="mailto:support@algolia.com">
                                support@algolia.com
                            </a>
                        </div>
                    </FlexGrid>
                </Card>

                <img
                    style={{ height: '30px', marginTop: '48px' }}
                    className="login-logo p-6"
                    src={algolia}
                    alt="Algolia"
                />
            </FlexGrid>
        </>
    )
}

export default ErrorBoundaryHtml
